import { Mapper } from "../domain/mappers/Mapper";
import { PhoneDTO, PhoneInfoForm } from "../domain/models/dto/PhoneDTO";
import { SimpleMapper } from "./SimpleMapper";

class PhoneMapperImpl extends SimpleMapper<PhoneInfoForm, PhoneDTO> {
    protected toDTOFields: string[] = ["id", "phone", "viber", "whatsapp"];
    protected fromDTOFields: string[] = [
        ...this.toDTOFields,
        "userId",
        "createdAt",
        "updatedAt",
    ];
}

export default function phoneMapperFactory(): Mapper<PhoneInfoForm, PhoneDTO> {
    return new PhoneMapperImpl();
}
